export default "__VITE_ASSET__ChDRSm$f__"